module.exports = __webpack_public_path__ + "images/4bf59ca09d4ec1dd5bcb0456cdb3602c.png";